export default __webpack_public_path__ + "img/landscape_2.d3cf0da2d98b977c4aae11a47f6d9f91.jpg";